import { ListIcon, MapIcon } from '@gemini/icons';
export const serpStaticAssetsPath = '/assets/apps/serp/v2/public';
export const mapStaticAssetsPath = '/assets/apps/serp_map/v2/public';
export const projectSerpStaticAssetsPath = '/assets/apps/serp_project/v1/public';
export const serpViewPaths = {
    list: 'classified-search',
    map: 'classified-map',
};
export var SavedSearchOrigin;
(function (SavedSearchOrigin) {
    SavedSearchOrigin["SEO_COMPONENT"] = "serp_seo_component";
    SavedSearchOrigin["MAP"] = "serp_map";
    SavedSearchOrigin["FULL_LIST"] = "serp_full_list";
})(SavedSearchOrigin || (SavedSearchOrigin = {}));
export const serpViewIconMap = {
    list: ListIcon,
    map: MapIcon,
};
export const MAX_RESULTS = 10000;
